import { useState } from "react";
import AccountLayout from "../layouts/AccountLayout";
import './../styles/change-password.css';
import { IoEye } from "react-icons/io5";
import { IoEyeOff } from "react-icons/io5";
import { ClipLoader } from "react-spinners";
import ToastNotification, { showTopCenterToast } from "../components/toasts/ToastNotification";
import { changePassword } from "../api/user.api";

export const ChangePassword = () => {
    const [isDisplay, setIsDisplay] = useState(false);

    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmNewPassword, setConfirmNewPassword] = useState("");

    const [loading, setLoading] = useState(false);

    const handleChangePassword = async () => {
        if (!currentPassword || !newPassword || !confirmNewPassword) {
            showTopCenterToast("Vui lòng nhập đầy đủ thông tin", "error");
            return;
        }

        if (confirmNewPassword !== newPassword) {
            showTopCenterToast("Xác nhận mật khẩu không đúng", "error");
            return;
        }

        try {
            setLoading(true);

            const res = await changePassword(currentPassword, newPassword, confirmNewPassword);

            if (res.success) {
                showTopCenterToast("Đổi mật khẩu thành công", "success");

                setCurrentPassword("");
                setNewPassword("");
                setConfirmNewPassword("");
            }
        } catch (error) {
            showTopCenterToast(error.message, "error");
        }
        finally {
            setLoading(false);
        }
    }

    return (
        <AccountLayout title={'Thay đổi mật khẩu'}>
            <div className="change-password-container">
                <h3>Cập nhật mật khẩu</h3>
                <div>
                    <p>Mật khẩu hiện tại</p>
                    <div className="pw-input-container">
                        <input onChange={(e) => setCurrentPassword(e.target.value)} type={`${isDisplay ? 'text' : 'password'}`} className="user-change-pw-input"></input>
                        {!isDisplay ?
                            <IoEye onClick={() => setIsDisplay(!isDisplay)} className="eye-pw-icon" />
                            :
                            <IoEyeOff onClick={() => setIsDisplay(!isDisplay)} className="eye-pw-icon" />}
                    </div>
                </div>
                <div>
                    <p>Mật khẩu mới</p>
                    <div className="pw-input-container">
                        <input onChange={(e) => setNewPassword(e.target.value)} type={`${isDisplay ? 'text' : 'password'}`} className="user-change-pw-input"></input>
                    </div>
                </div>
                <div>
                    <p>Xác nhận mật khẩu mới</p>
                    <div className="pw-input-container">
                        <input onChange={(e) => setConfirmNewPassword(e.target.value)} type={`${isDisplay ? 'text' : 'password'}`} className="user-change-pw-input"></input>
                    </div>
                </div>
                <button onClick={handleChangePassword} className={`change-pw-button ${loading && "disabled-button"}`}>{loading ? <ClipLoader color="#fff" size={20}/> : "Đổi mật khẩu" }</button>
            </div>
            <ToastNotification/>
        </AccountLayout>
    )
}